import React from "react";

type ModalProps = {
  children: React.ReactNode;
  title: string;
  id: string;
};

const Modal = ({ children, id, title }: ModalProps) => {
  return (
    <>
      <dialog id={id} className="modal">
        <div className="modal-box bg-white">
          <form method="dialog">
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
              ✕
            </button>
          </form>
          <h3 className="font-bold text-lg">{title}</h3>
          <div className="py-4">{children}</div>
        </div>
        <form method="dialog" className="modal-backdrop">
          <button>close</button>
        </form>
      </dialog>
    </>
  );
};

export default Modal;
